import "./Globals";
import { createApp } from "vue";
import { initSentry } from "./helpers/sentry";
import { createPinia } from "pinia";

import "vuetify/styles";
import { aliases, mdi } from "vuetify/iconsets/mdi";
import { createVuetify } from "vuetify";
import * as components from "vuetify/components";
import * as directives from "vuetify/directives";
import { en, pt } from "vuetify/locale";

import { CkeditorPlugin } from "@ckeditor/ckeditor5-vue";
import "ckeditor5/ckeditor5.css";
import "ckeditor5-premium-features/ckeditor5-premium-features.css";

import App from "./App.vue";
import router from "./router";
import { registerPattern, vMask } from "@termehui/vmask";
import i18n from "./helpers/i18n";
import "/node_modules/flag-icons/css/flag-icons.min.css";
import { VTimePicker } from 'vuetify/lib/labs/components.mjs';
import Vue3Toastify, { type ToastContainerOptions } from 'vue3-toastify';
import { registerAsciiOnlyDirective } from "./directives/asciiOnly";

const app = createApp(App);

const vuetify = createVuetify({
  components: {
    ...components,
    VTimePicker,
  },
  directives,
  icons: {
    defaultSet: "mdi",
    aliases,
    sets: {
      mdi,
    },
  },
  locale: {
    locale: "pt",
    fallback: "en",
    messages: { pt, en },
  },
});

registerPattern("N", RegExp("^(?!.* {3})[0-9+ ]+$|^(?! )(?!.* $)[0-9+ ]+$"));

app.use(createPinia());
app.use(router);
app.use(vuetify);
app.use(i18n);

app.use(Vue3Toastify, {
  clearOnUrlChange: false,
} as ToastContainerOptions);
app.use(CkeditorPlugin);

app.directive("mask", vMask);
registerAsciiOnlyDirective(app);

initSentry(app, router);

app.mount("#app");
